export default __webpack_public_path__ + "static/media/recsys.dd94e9f6.svg";